module.exports = __webpack_public_path__ + "img/natudrin-3-unidades-1024x1024.c241f5ef.png";